export default __webpack_public_path__ + "49fd40125a8729443d9ef0384f5db036.png";